import React, { Component, Fragment, useContext } from "react";
import {
    Modal,
    Button,
    Card,
    useAccordionToggle,
    AccordionContext,
    Accordion,
} from "react-bootstrap";
import _ from "lodash";
import Skeleton from "react-loading-skeleton";
import BaseFormComponent, { IBaseFormState } from "../../../../components/BaseFormComponent";
import textFormatService from "../../../../services/utility/textFormatService";
import ItemsTable, { filterFieldData } from "../../../../components/tableComponents/itemsTable";
import TableFilterPane from "../../../../components/tableComponents/tableFilterPane";
import { getCurrentUserSession } from "../../../../services/auth/authService";
// import TinRequestDetails from "../../../../loanAppraisal/appraisalDetailPages/TinRequestDetails";
// import { ContextAwareToggle } from "./documentCollection";
import { decodeToken } from "react-jwt";
import BaseListComponent, { IFilterData } from "../../../../components/BaseListComponent";
import loanProductService from "../../../../services/hybridAppraisal/loanProductService";
import loanRequestService from "../../../../services/hybridAppraisal/loanRequestService";
import { createFilterData, mapEntityList } from "../../../../services/utility/autoMapperService";
import TinValidationDetailsModal from "./tinValidationModal";
import DetailItemsTable, { TableContext } from "../../../../components/tableComponents/detailItemsTable";

interface TinValidationListModalFields { }

class TinValidationListModalForm extends BaseFormComponent<TinValidationListModalFields> { }

interface ITinValidationListModalProps {
    item: any;
    members: any;
    showPatchModal: boolean;
    togglePatchModal: any;
}

interface ITinValidationListModalState {
    item: any;
    updatingStatus: boolean;
    submitting: boolean;
    data: IFilterData;
    currentPage: number;
    pageSize: number;
    tableItems: any;
    fetching: boolean;
    fetchingDetail: boolean;
    totalSize: number;
    filterValueInput: filterFieldData;
    userRoles: any;
    systemProcess: any;
    applicableRules: any;
    appraisalActions: any;
    updateComponent: boolean;
    documentsToUpload: any;
    documentsToDelete: number[];
    canEditItem: boolean;
    updateAvailable: boolean;
    processResponse: any;
    specialConditions: any;
    ownUpdate: boolean;
    showTinDetails: boolean;
    members: any;
    member: any;
}

class TinValidationListModalList extends BaseListComponent<ITinValidationListModalState> { }

class TinValidationListModal extends React.Component<
    ITinValidationListModalProps,
    IBaseFormState & ITinValidationListModalState
> {
    _isMounted = false;
    constructor(props: ITinValidationListModalProps) {
        super(props);
        this.state = {
            validated: false,
            submitting: false,
            errors: {},
            item: {},
            updatingStatus: false,
            data: createFilterData(["customerName", "loanType"]) as IFilterData,
            currentPage: 1,
            pageSize: Number(process.env.REACT_APP_DEFAULT_PAGESIZE) || 10,
            fetching: false,
            fetchingDetail: false,
            tableItems: [],
            totalSize: 0,
            filterValueInput: [
                { name: "customerName", fieldType: "text", value: "" },
                {
                    name: "loanType",
                    fieldType: "select",
                    options: ["Individual", "Corporate"],
                    value: "",
                }
            ],
            userRoles: [],
            systemProcess: [],
            applicableRules: [],
            appraisalActions: [],
            documentsToUpload: [],
            documentsToDelete: [],
            updateComponent: false,
            canEditItem: false,
            updateAvailable: false,
            specialConditions: [],
            processResponse: {
                actionId: 0,
                score: 0,
                response: ""
            },
            ownUpdate: false,
            showTinDetails: false,
            members: [],
            member: {}
        };
    }

    resetFields() {
        this.setState({
            validated: false,
            submitting: false
        });
    }

    async componentDidMount() {
        this._isMounted = true
        this.handlePageChange(this.state.currentPage, this.state.pageSize)
    }
    componentWillUnmount() {
        this._isMounted = false
    }

    handlePageChange = async (currentPage: number, pageSize: number, data?: IFilterData) => {
        currentPage = currentPage < 0 ? this.state.currentPage : currentPage;
        pageSize = pageSize < 0 ? this.state.pageSize : pageSize;
        if (this._isMounted) {
            this.setState({ fetching: true, ownUpdate: true });
        }

        try {
            const tinValidationMembersList: any = [];

            var groupMembersList = this.props.members;
            // console.log(groupMembersList)

            if (groupMembersList) {
                groupMembersList?.forEach(x => {
                    const tinValidationMembers: any = {};

                    tinValidationMembers.id = x.id
                    tinValidationMembers.title = x.title
                    tinValidationMembers.phoneNumber = x.phoneNumber
                    tinValidationMembers.customerName = x.customerName
                    tinValidationMembers.tinResult = x.loanDetails.length > 0 ? "Matched" : "Mo-Match";
                    tinValidationMembers.tinResponse = x.loanDetails



                    tinValidationMembersList.push(tinValidationMembers)
                });
            }

            const membersPaginated: any = [];
            const totalLength = tinValidationMembersList.length;
            const initial = (currentPage - 1) * 10;
            for (let i = initial; i < initial + 10; i++) {
                membersPaginated.push(tinValidationMembersList[i]);
                if (i === totalLength - 1) {
                    break;
                }
            }
            if (this._isMounted) {
                this.setState({
                    tableItems: mapEntityList({
                        entityList: membersPaginated,
                        properties: [
                            { oldName: "title", newName: "title" },
                            { oldName: "customerName", newName: "customerName" },
                            { oldName: "tinResult", newName: "tinResult" },
                        ],
                    }),
                    currentPage,
                    pageSize,
                    totalSize: tinValidationMembersList.length,
                    fetching: false,
                    ownUpdate: true,
                    members: tinValidationMembersList
                });
            }
        } catch (ex) {
            if (ex.response && ex.response.status >= 400 && ex.response.status <= 499) {
                if (this._isMounted) {
                    this.setState({ fetching: false, ownUpdate: true });
                }
            } else {
                if (this._isMounted) {
                    this.setState({ fetching: false, ownUpdate: true });
                }
            }
        } finally {
            if (this._isMounted) {
                this.setState({ fetching: false, ownUpdate: true });
            }
        }
    };
    getFilteredItems = (data: IFilterData): IFilterData => {
        let filteredItems: IFilterData = {};
        Object.keys(data).forEach((key) => {
            if (data[key].item2 !== "") {
                filteredItems[key] = data[key];
            }
        });
        return filteredItems;
    };

    static getDerivedStateFromProps(nextProps: ITinValidationListModalProps) {
        return {
            item: nextProps.item,
        };
    }
    fetchItemById = (id) => {
        const member = this.state.members.filter(x => x.id === id)

        this.setState({ member: member })
    }

    toggleTinModal = () => {
        this.setState({ showTinDetails: !this.state.showTinDetails });
    };

    handleOnExport = async (type: string) => { };

    render() {
        const { item, showPatchModal, togglePatchModal } = this.props;
        const {
            currentPage,
            pageSize,
            tableItems,
            totalSize,
            fetching,
            fetchingDetail,
            submitting,
            members
        } = this.state;

        // console.log(item)
        if (_.isEmpty(item)) {
            return null;
        }

        const tableContext: TableContext = {
            name: "",
            primaryValue: "",
            successValue: "Successful",
            dangerValue: "Failed",

        };

        return (
            <Modal
                size="xl"
                backdrop="static"
                show={showPatchModal}
                onHide={togglePatchModal}
            >
                <Modal.Header>
                    <Modal.Title>
                        <h5>
                            <i className="fas fa-edit fa-sm cyan-text mr-3" />
                            Tin Validation for Solidarity Group
                        </h5>
                    </Modal.Title>
                </Modal.Header>
                <TinValidationListModalForm
                    initialValues={{}}
                    FormComponent={({
                        fields: { }, onChange, onReloadFields, onHandleSubmit,
                    }) => (
                        <React.Fragment>
                            <Modal.Body>
                                <div className="card">
                                    <div className="card-header clear-fix">
                                        {_.isEmpty(item) ? (
                                            <Skeleton width={200} />
                                        ) : (
                                            <h6
                                                className="card-title float-left"
                                                style={{ marginBottom: "0px" }}
                                            >
                                                <b>Tin Validation for {item.customerName} - {this.props.members[0]?.solidarityGroupName}</b>
                                            </h6>
                                        )}
                                    </div>
                                    <div className="card">
                                        <Accordion defaultActiveKey="0">
                                            <div>
                                                <Card>
                                                    <Accordion.Collapse eventKey={`0`}>
                                                        <Card.Body>
                                                            <TinValidationListModalList
                                                                pageChangeHandler={this.handlePageChange}
                                                                fetchingDetail={fetchingDetail}
                                                                initialValues={{
                                                                    data: this.state.data,
                                                                    fetching: false,
                                                                    showDetailsModal: false,
                                                                    showEditModal: false,
                                                                    showTableFilterModal: false,
                                                                    showTrailModal: false,
                                                                    tableItems: [],
                                                                    filterValueInput: this.state.filterValueInput,
                                                                    item: {},
                                                                }}
                                                                tableItems={tableItems}
                                                                item={members}
                                                                DetailsModal={({
                                                                    item, onToggleDetailsModal, onToggleEditModal, showDetailsModal, showEditModal
                                                                }) => (
                                                                    <Fragment>
                                                                        <TinValidationDetailsModal
                                                                            item={this.state.item}
                                                                            members={this.state.member}
                                                                            showPatchModal={this.state.showTinDetails}
                                                                            togglePatchModal={this.toggleTinModal} />
                                                                    </Fragment>

                                                                )}
                                                                ListPayLoad={({
                                                                    data, showTableFilterModal, tableItems, onToggleDetailsModal, onToggleTableFilterModal, onHandleFilterItemRemove, filterValueInput,
                                                                }) => (
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <div className="card no-b">
                                                                                <div className="card-body">
                                                                                    <div className="card-title">
                                                                                        <div id="list-filters" className="ml-4 mr-4">
                                                                                            <TableFilterPane
                                                                                                filteredItems={this.getFilteredItems(data)}
                                                                                                handleFilterRemove={onHandleFilterItemRemove} />
                                                                                        </div>
                                                                                        <div id="list-table">
                                                                                            {/* <ItemsTable
                                                                                                data={data}
                                                                                                items={tableItems}
                                                                                                filterValueInput={filterValueInput}
                                                                                                showTableFiltermodal={showTableFilterModal}
                                                                                                toggleTableFiltermodal={onToggleTableFilterModal}
                                                                                                name="Tin Validation fo Solidarity Group"
                                                                                                currentPage={currentPage}
                                                                                                pageSize={pageSize}
                                                                                                totalSize={totalSize}
                                                                                                fetching={fetching}
                                                                                                handlePageChange={this.handlePageChange}
                                                                                                onViewDetails={(item: any) => {
                                                                                                    this.fetchItemById(item.id)
                                                                                                    this.toggleTinModal();
                                                                                                }}
                                                                                                handleOnExport={this.handleOnExport}
                                                                                                timeColumn={["dateCreated"]}
                                                                                                amountColumn={["loanAmount"]} /> */}
                                                                                            <DetailItemsTable
                                                                                                title="Tin Validation fo Solidarity Group"
                                                                                                item={item}
                                                                                                handleOnPageChange={
                                                                                                    this.handlePageChange
                                                                                                }
                                                                                                content={tableItems}
                                                                                                contentCount={totalSize}
                                                                                                page={currentPage}
                                                                                                onViewDetails={(item: any) => {
                                                                                                    this.fetchItemById(item.id)
                                                                                                    this.toggleTinModal();
                                                                                                }}
                                                                                                hasDetailModal={true}
                                                                                                fetching={fetching}
                                                                                                amountColumn={["loanAmount"]}
                                                                                                timeColumn={["dateCreated"]}
                                                                                                contextualColumn={tableContext}
                                                                                                emptyTitle="Tin Validation fo Solidarity Group"
                                                                                            />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            ></TinValidationListModalList>

                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            </div>
                                        </Accordion>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    size="sm"
                                    variant="outline-danger"
                                    onClick={() => togglePatchModal(false, {}, {})}
                                    disabled={submitting}
                                >
                                    <i className="fas fa-times mr-3" />
                                    Close
                                </Button>
                            </Modal.Footer>
                        </React.Fragment>
                    )}
                ></TinValidationListModalForm>
            </Modal>
        );
    }
}

export default TinValidationListModal;
